import React from 'react';
import './ChangePswd.css'

const ChangePswd = () => {
   
return(
<div>
    <div className="container">
      <img src="../assets/Profile.png" alt="profile-icon" className="profile_ChangePswd"/>
      <h2 className="change_password_ChangePswd">Change Password</h2>
      <br />
      <input type="text_ChangePswd" placeholder="Password" name="email" /><br /><br />
      <input type="password_ChangePswd" placeholder="Confirm Password" name="email" /><br />
      <br />
      <br />
      <button className="done_ChangePswd" type="submit" >Done</button>
    </div> 
</div>
    )
}

export default ChangePswd;